import { Controller } from "@hotwired/stimulus"

// This Stimulus controller disables or enables an editable element (like a textarea)
// based on the state of a toggle checkbox. When the toggle is checked, the editable
// element is disabled and reset to its original content. When unchecked, it becomes
// editable. This is useful for toggling between using default content and allowing
// user customization.
//
// Targets:
//   - toggler: a checkbox input element
//   - editable: the element whose editable state and content is controlled

// Value:
//   - defaultContent: the content to display when the toggle is checked (i.e reset to default content)
//
// Example usage:
//   <form data-controller="template-lock-toggle" data-template-lock-toggle-default-content-value="Default content">
//     <textarea data-template-lock-toggle-target="editable">Default content</textarea>
//     <input type="checkbox" data-template-lock-toggle-target="toggler" data-action="template-lock-toggle#toggle" checked>
//   </form>

export default class extends Controller {
  static targets = ["toggler", "editable"]
  static values = {
    defaultContent: String,
  }

  connect() {
    this.toggle()
  }

  toggle() {
    if (this.togglerTarget.checked) {
      this.editableTarget.disabled = true
      this.editableTarget.value = this.defaultContentValue
    } else {
      this.editableTarget.disabled = false
    }

    this.triggerTexareaResize()
  }

  triggerTexareaResize() {
    this.editableTarget.dispatchEvent(new Event('input'))
  }
}